export const AVAILABLE_RENDER_FROM = [
    'checkout',
    'checkoutLanding',
    'loginPage',
    'myaccount',
    'landing',
    'modal'
] as const;
